var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayWhiteOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07532 7.41154C7.07532 7.3309 7.16144 7.28064 7.22993 7.32043L15.1866 11.9082C15.2219 11.9281 15.2385 11.9647 15.2385 11.9993C15.2385 12.0349 15.2219 12.0705 15.1866 12.0904L9.5854 15.321L7.22993 16.6792C7.16144 16.719 7.07532 16.6676 7.07532 16.5881V7.41154ZM18.7385 11.5448L5.77616 4.06998C5.69315 4.02181 5.60495 3.99982 5.51986 3.99982C5.38393 3.99982 5.25422 4.05427 5.15772 4.14747C5.06226 4.24067 5 4.37157 5 4.52446V19.4752C5 19.6281 5.06226 19.759 5.15772 19.8511C5.25422 19.9443 5.38393 19.9998 5.51986 19.9998C5.60495 19.9998 5.69315 19.9778 5.77616 19.9297L18.7385 12.4538C18.9128 12.3532 19 12.1763 19 11.9993C19 11.8223 18.9128 11.6453 18.7385 11.5448V11.5448Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhiteOutline);
export default __webpack_public_path__ + "static/media/play-white-outline.77f3d7b0ab3aa96fc3ec0cd9490cba00.svg";
export { ForwardRef as ReactComponent };